import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { IWithCustomStyle } from "@/hooks/useTheme/types";
import { Image } from "@/components/Image";

import { ILogoProvider } from "./types";

type IProps = ILogoProvider & IWithCustomStyle;

export const LogoProvider: React.FC<IProps> = ({
  title,
  src,
  customStyle = {},
  ...rest
}) => {
  const { css } = useFela();
  const { colors } = useTheme();

  return (
    <div
      title={title}
      className={css(
        {
          height: 64,
          margin: "6px 8px",
          display: "flex",
          borderRadius: 8,
          padding: "16px 26px",
          alignItems: "center",
          backgroundColor: colors.WHITE,
          boxShadow: `20px 20px 80px 0 ${colors.CETACEAN_BLUE}`,
        },
        customStyle,
      )}
      {...rest}
    >
      <Image alt={title} src={src} />
    </div>
  );
};

export type { ILogoProvider };
